// extracted by extract-css-chunks-webpack-plugin
module.exports = {"period-display":"styles__period-display___1kCsm","periodDisplay":"styles__period-display___1kCsm"};
    if(module.hot) {
      // 1775777248668
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  